import { render, staticRenderFns } from "./AlertPreference.vue?vue&type=template&id=2cdd73b0&scoped=true"
import script from "./AlertPreference.vue?vue&type=script&lang=js"
export * from "./AlertPreference.vue?vue&type=script&lang=js"
import style0 from "./AlertPreference.vue?vue&type=style&index=0&id=2cdd73b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd73b0",
  null
  
)

export default component.exports